import { getApplicationInsightsSingleton } from "../contexts/application-insights/application-insights.provider";

/**
 * @deprecated Use the managed Application Insights instance via the React context and `useApplicationInsights` hook instead.
 * This function exists for legacy purposes only.
 */
export const getUnmanagedApplicationInsights = () => {
	return getApplicationInsightsSingleton();
};
